/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSeatCapabilities } from "./FlightSeatCapabilities";
import {
  FlightSeatCapabilitiesFromJSON,
  FlightSeatCapabilitiesFromJSONTyped,
  FlightSeatCapabilitiesToJSON,
  FlightSeatCapabilitiesToJSONTyped,
} from "./FlightSeatCapabilities";

/**
 *
 * @export
 * @interface FlightSelectedSeat
 */
export interface FlightSelectedSeat {
  /**
   * Opaque provider-bound seat reference. Clients must not reconstruct supplier identities from it.
   * @type {string}
   * @memberof FlightSelectedSeat
   */
  serviceId: string;
  /**
   *
   * @type {FlightSeatCapabilities}
   * @memberof FlightSelectedSeat
   */
  capabilities?: FlightSeatCapabilities;
  /**
   *
   * @type {number}
   * @memberof FlightSelectedSeat
   */
  passengerIndex: number;
  /**
   *
   * @type {number}
   * @memberof FlightSelectedSeat
   */
  segmentIndex: number;
  /**
   *
   * @type {string}
   * @memberof FlightSelectedSeat
   */
  designator: string;
  /**
   *
   * @type {number}
   * @memberof FlightSelectedSeat
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof FlightSelectedSeat
   */
  currency: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FlightSelectedSeat
   */
  disclosures: Array<string>;
}

/**
 * Check if a given object implements the FlightSelectedSeat interface.
 */
export function instanceOfFlightSelectedSeat(
  value: object
): value is FlightSelectedSeat {
  if (!("serviceId" in value) || value["serviceId"] === undefined) return false;
  if (!("passengerIndex" in value) || value["passengerIndex"] === undefined)
    return false;
  if (!("segmentIndex" in value) || value["segmentIndex"] === undefined)
    return false;
  if (!("designator" in value) || value["designator"] === undefined)
    return false;
  if (!("amount" in value) || value["amount"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("disclosures" in value) || value["disclosures"] === undefined)
    return false;
  return true;
}

export function FlightSelectedSeatFromJSON(json: any): FlightSelectedSeat {
  return FlightSelectedSeatFromJSONTyped(json, false);
}

export function FlightSelectedSeatFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSelectedSeat {
  if (json == null) {
    return json;
  }
  return {
    serviceId: json["service_id"],
    capabilities:
      json["capabilities"] == null
        ? undefined
        : FlightSeatCapabilitiesFromJSON(json["capabilities"]),
    passengerIndex: json["passenger_index"],
    segmentIndex: json["segment_index"],
    designator: json["designator"],
    amount: json["amount"],
    currency: json["currency"],
    disclosures: json["disclosures"],
  };
}

export function FlightSelectedSeatToJSON(json: any): FlightSelectedSeat {
  return FlightSelectedSeatToJSONTyped(json, false);
}

export function FlightSelectedSeatToJSONTyped(
  value?: FlightSelectedSeat | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    service_id: value["serviceId"],
    capabilities: FlightSeatCapabilitiesToJSON(value["capabilities"]),
    passenger_index: value["passengerIndex"],
    segment_index: value["segmentIndex"],
    designator: value["designator"],
    amount: value["amount"],
    currency: value["currency"],
    disclosures: value["disclosures"],
  };
}
